import { inject, provide, ref } from "vue";
// View-scoped, read-only context for in-session transcript edits. The hosting
// view owns the live char-range map plus the store action that updates it;
// this context exposes only the map so the shared TranscriptMessage can render
// the green styling. Char ranges are immune to BE token re-segmentation,
// which would invalidate raw word-index storage. Lifetime matches the
// providing view: on remount the view rebuilds an empty map, so revisiting
// the page clears the session-green state.
export const TRANSCRIPT_EDIT_CONTEXT_KEY = Symbol();
export const initTranscriptEditContext = (editedRangesBySegment) => {
    provide(TRANSCRIPT_EDIT_CONTEXT_KEY, { editedRangesBySegment });
};
// Safe default: non-providing parents get an empty Map ref so the consumer
// never highlights and never throws.
export const useTranscriptEditContext = () => {
    return inject(TRANSCRIPT_EDIT_CONTEXT_KEY, {
        editedRangesBySegment: ref(new Map())
    });
};
